import {useCallback, useEffect, useRef, useState } from "react";
import { useAuth, useLocalStorage, useOnBoarding } from "_hooks";
import { Base } from "components/template";
import { Button, Icon } from "components/atoms";
import { ProgressBar } from "components/molecules";
import logo from "_utilities/images/logo.png";

const prefix = "v-create-account";

let interval;

const CreateAccount = () => {
  const { goToAccount } = useAuth();
  const [step, setStep] = useState(1);
  const initialized = useRef(null);

  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const [, setOBEmail] = useLocalStorage("OBEmail");
  const {
    account,
    accountError,
    accountIsLoading,
    demoError,
    createDemo,
    createAccount
  } = useOnBoarding();

  const animation = useCallback(() => {
    interval = setInterval(() => { 
      setStep((s) => {
        if (s < 3) {
          return s + 1
        }
        clearInterval(interval);
        return s;
      });
    }, [1000]);
  }, []);

  const init = useCallback(() => {
    if (!accountIsLoading) {
      createAccount(onBoarding?._id).then(({ data: account }) => {
        setStep(4);
        if (account?._id) {
          createDemo(account._id).then(() => setStep(5));
        }
      });
    }
  }, [accountIsLoading, onBoarding, createAccount, createDemo]);

  useEffect(() => {
    if (!initialized?.current) {
      initialized.current = true;
      animation();
      init();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (account) {
      setOnBoarding();
      setOBEmail();
    }
  }, [account]);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-4/5 md:w-3/5 lg:w-3/5 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-5 text-center">
          <div className="">
            <Icon icon="check" className={`text-green-500 mx-auto text-6xl ${!(step === 5 && (!accountError  && !demoError)) && "hidden"}`} />
            <Icon icon="closeCircle" className={`text-red-500 mx-auto text-6xl ${!(step >= 4 && (!!accountError  || !!demoError)) && "hidden"}`} />
          </div>
          <div>
            <img src={logo} alt="logo" className="max-h-8 mx-auto"/>
          </div>
          <div className="max-w-[100%]">
            {(!!accountError || !!demoError) ?
              <ProgressBar max={5} progress={step} color="red-500" />
              :
              <ProgressBar max={5} progress={step} color="primary" />
            }
          </div>
          <p className="text-3xl font-bold">
            {(step < 4 && accountIsLoading) && "Creando cuenta"}
            {(step === 4 && !!account && !accountError) && "Cargando productos demo"}
            {(step === 5 && !!account && !accountError) && "Cuenta creada correctamente"}

            {(step >= 4  && !account && (!!accountError || !!demoError)) && "Algo salió mal"}
          </p>
          
          <div>
            <p className="text-lg">
              {step < 4 && "Esto puede tomar algunos minutos"}
              {(step >= 4 && (!!accountError || !!demoError)) && "Ponte en contacto con soporte"}
            </p>
          </div>
          
          {(step >= 4 && (!!accountError || !!demoError)) && <div>
            <p className="text-lg font-bold">
              <a href="mailto:soporte@nubesk.com.mx" className="underline">soporte@nubesk.com.mx</a>
            </p>
          </div>}

          {step === 5 && !accountError && !demoError && 
            <Button
              className="bg-primary text-white rounded-lg"
              fullwidth
              pulse
              onClick={() => goToAccount({ token: account?.config?.userId?.tokenAccess })}
            >
              Ir a mi cuenta
            </Button>
          }
        </div>
      </div>
    </Base>
  );
};

export default CreateAccount;
